<template>
  <v-container fluid class="crm-integration pa-0" style="margin-top: 70px; margin-bottom: 70px;">
    <v-row class="justify-center">
      <v-col cols="12" lg="10">
        <v-card class="main-card" v-if="!operationSettings">
          <!-- Header -->
          <div class="card-header">
            <v-btn @click="backToTableData()" icon class="back-button ml-4">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            <h1 class="text-h4 font-weight-bold primary-text mb-0">
              אינטיגרציה ל CRM - {{ tableName.hebrew_name }}
            </h1>
          </div>

          <v-divider></v-divider>

          <!-- Trigger List -->
          <div v-if="!isTrigerChoosed" class="pa-6">
            <h2 class="text-h6 font-weight-medium mb-6">פעיל כאשר:</h2>
            <v-row>
              <v-col cols="12" sm="6" md="4" v-for="(triger, index) in trigers" :key="index">
                <v-hover v-slot="{ hover }">
                  <v-card min-height="100" class="trigger-card" :class="{ 'on-hover': hover }"
                    @click="openOperationsList(triger)">
                    <div class="trigger-card-content">
                      <v-badge v-if="calcTrigerOperationsCount(triger) > 0" :content="calcTrigerOperationsCount(triger)"
                        color="#0d2c6d" class="trigger-badge" offset-y="20" offset-x="-7"></v-badge>
                      <div class="trigger-text">
                        <h3 class="text-h6 font-weight-bold mb-0">
                          {{ triger.hebrew_name }}
                        </h3>
                      </div>
                    </div>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </div>

          <!-- Operations List with Drag and Drop -->
          <div v-else class="pa-6">
            <div class="d-flex align-center justify-space-between mb-6">
              <h2 class="text-h6 font-weight-medium mb-0">
                פעולות כאשר '{{ trigerChoosed.hebrew_name }}'
                <span class="text-subtitle-1 text-medium-emphasis">
                  ({{ operations.length }} פעולות)
                </span>
              </h2>
              <v-btn color="primary" @click="createDialog = true" class="add-button">
                <v-icon left>mdi-plus</v-icon>
                הוסף פעולה
              </v-btn>
            </div>

            <!-- Draggable Operations -->
            <!-- <v-row>
              <draggable v-model="operations" @end="onDragEnd" :options="dragOptions" class="operations-container"> -->
            <!-- Draggable Operations -->
            <draggable v-model="operations" @start="onDragStart" @end="onDragEnd" animation="100" group="operations"
              :disabled="false" ghost-class="ghost-card" chosen-class="chosen-card" drag-class="drag-card"
              handle=".drag-handle"  tag="div" :component-data="{
                tag: 'div',
                type: 'transition-group',
                name: 'operation-list'
              }">
              <transition-group name="operation-list" tag="div" class="horizontal-row">
                <div v-for="(operation, index) in operations" :key="operation.id || index" class="operation-col">
                  <v-hover v-slot="{ hover }">
                    <v-card class="operation-card draggable-card"
                      :class="{ 'on-hover': hover, 'dragging': isDragging }">
                      <!-- Drag Handle -->
                      <div class="drag-handle">
                        <v-icon color="grey lighten-1" size="20">mdi-drag-vertical</v-icon>
                      </div>

                      <v-card-text class="text-center">
                        <h3 class="text-h6 font-weight-bold mb-2">
                          {{ operation.name }}
                        </h3>
                        <div class="status-chip"
                          :class="operation.action.mode === 'on' ? 'status-active' : 'status-inactive'">
                          {{ operation.action.mode === 'on' ? 'פעיל' : 'לא פעיל' }}
                        </div>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions class="justify-center">
                        <v-btn text color="primary" @click="openOperationSettings(operation, index)">
                          <v-icon left>mdi-cog</v-icon>
                          ערוך פעולה
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </div>
              </transition-group>
            </draggable>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogs -->
    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

    <CreateDialog v-model="createDialog" v-if="createDialog" @operationCreated="operationCreated" :tableName="tableName"
      :trigerName="trigerChoosed.name" />

    <OperationSettings v-model="operationSettings" v-if="operationSettings" :operationToEdit="operationToEdit"
      @operationUpdated="operationUpdated" :tableName="tableName" />
  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service.js'
import SnackBar from '@/components/widgets/snackBar.vue'
import Auth from '@/services/auth.service.js'
import CreateDialog from '@/components/user/crmIntigration/CreateOperationDialog'
import OperationSettings from '@/components/user/crmIntigration/OperationSettings'
import draggable from 'vuedraggable'

export default {
  components: {
    SnackBar,
    CreateDialog,
    OperationSettings,
    draggable,
  },
  props: {
    tableName: Object,
    value: { type: Boolean, default: false },
  },
  data: () => ({
    operations: [],
    trigers: [],
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    createDialog: false,
    operationSettings: false,
    operationToEdit: {},
    trigerChoosed: "",
    isTrigerChoosed: false,
    isDragging: false,
    // dragOptions: {
    //   animation: 200,
    //   group: "operations",
    //   disabled: false,
    //   ghostClass: "ghost-card",
    //   chosenClass: "chosen-card",
    //   dragClass: "drag-card",
    //   handle: ".drag-handle"
    // }
  }),
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  methods: {
    async getOperations() {
      try {
        this.operations = [];
        let token = localStorage.getItem("token");
        const tableJSON = JSON.stringify({ tableName: this.tableName.name, triger: this.trigerChoosed.name });

        let api = process.env.VUE_APP_BASE_URL + "/user/get_table_crm_operations";
        const res = await fetch(api, ApiServices.requestOptions("POST", tableJSON, token));
        const jsonObject = await res.json();
        if (res.status >= 400) {
          this.showSnackBar(" שגיאה בקבלת נתונים" + jsonObject.message, "red");
        } else if (res.status === 200) {
          this.operations = jsonObject.operations;
          this.trigers = jsonObject.trigers;
          if (this.trigerChoosed) {
            this.operations = this.operations.filter(operation => operation.triger === this.trigerChoosed.name)
            // Sort operations by position if available
            this.operations.sort((a, b) => (a.position || 0) - (b.position || 0));
          }
        }
      } catch (error) {
        this.showSnackBar("Error get operations list: " + error, "red");
      }
    },
    async updateWebhooksPositions() {
      try {
        // Update position property for each operation based on current order
        const updatedOperations = this.operations.map((operation, index) => ({
          ...operation,
          position: index + 1
        }));

        let token = localStorage.getItem("token");
        const webhooksJSON = JSON.stringify(updatedOperations);

        let api = process.env.VUE_APP_BASE_URL + "/user/update_crm_operation_position";
        const res = await fetch(api, ApiServices.requestOptions("PUT", webhooksJSON, token));
        const jsonObject = await res.json();

        if (res.status >= 400) {
          this.showSnackBar("שגיאה בעדכון המיקום: " + jsonObject.message, "red");
        } else {
          this.showSnackBar("המיקום עודכן בהצלחה", "green");
          // Update local operations with new positions
          this.operations = updatedOperations;
        }
      } catch (error) {
        this.showSnackBar("Error update webhooks positions: " + error, "red");
      }
    },
    onDragEnd(event) {
      this.isDragging = false;
      console.log(3333);
      console.log(event);
      if (event.oldIndex === event.newIndex) {
        return;
      }
      // Call updateWebhooksPositions after drag ends
      this.updateWebhooksPositions();
    },
    onDragStart() {
      this.isDragging = true;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    operationCreated(item, text, color) {
      this.showSnackBar(text, color);
      this.getOperations()
    },
    openOperationSettings(operation, index) {
      this.operationToEdit = operation;
      this.operationSettings = true
    },
    openOperationsList(triger) {
      this.trigerChoosed = triger;
      this.operations = this.operations.filter(operation => operation.triger === this.trigerChoosed.name)
      // Sort by position when opening operations list
      this.operations.sort((a, b) => (a.position || 0) - (b.position || 0));
      this.isTrigerChoosed = true;
    },
    calcTrigerOperationsCount(triger) {
      return this.operations.filter(operation => operation.triger === triger.name).length
    },
    operationUpdated(operation, text, color) {
      this.showSnackBar(text, color);
      this.operationSettings = false;
      this.getOperations();
    },
    backToTableData() {
      if (this.isTrigerChoosed) {
        this.trigerChoosed = "";
        this.isTrigerChoosed = false;
        this.getOperations();
      } else {
        this.$emit('backToTableData', this.tableName)
      }
    }
  },
  mounted() {
    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
    this.getOperations();
  },
}
</script>

<style scoped>
.crm-integration {
  background: linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%);
  min-height: 100vh;
  padding-top: 70px;
  padding-bottom: 90px;
}

.main-card {
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 24px rgba(13, 44, 109, 0.08);
}

.card-header {
  padding: 1.5rem;
  background: linear-gradient(to bottom, rgba(13, 44, 109, 0.02), transparent);
  display: flex;
  align-items: center;
}

.primary-text {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.back-button {
  background: rgba(13, 44, 109, 0.05);
  transition: all 0.3s ease;
}

.back-button:hover {
  background: rgba(13, 44, 109, 0.1);
  transform: translateX(2px);
}

.back-button .v-icon {
  color: #0d2c6d;
}

/* Trigger Cards */
.trigger-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 1px solid rgba(13, 44, 109, 0.1);
  background: linear-gradient(135deg, rgba(13, 44, 109, 0.02) 0%, rgba(13, 44, 109, 0.05) 100%);
  cursor: pointer;
  min-height: 100px;
}

.trigger-card.on-hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(13, 44, 109, 0.12);
  border-color: rgba(13, 44, 109, 0.2);
}

.trigger-card-content {
  position: relative;
  height: 100%;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trigger-badge {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}

.trigger-text {
  text-align: center;
  padding: 1rem;
}




.operation-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 1px solid rgba(13, 44, 109, 0.1);
  position: relative;
}

.operation-card.on-hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(13, 44, 109, 0.12);
  border-color: rgba(13, 44, 109, 0.2);
}

.draggable-card {
  user-select: none;
}

.draggable-card.dragging {
  opacity: 0.8;
  transform: rotate(5deg);
}

/* Drag Handle */
.drag-handle {
  position: absolute;
  top: 8px;
  left: 8px;
  cursor: grab;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  z-index: 2;
}

.drag-handle:hover {
  background-color: rgba(13, 44, 109, 0.1);
}

.drag-handle:active {
  cursor: grabbing;
}

/* Drag States */
.ghost-card {
  opacity: 0.5;
  background: rgba(13, 44, 109, 0.1);
  border: 2px dashed rgba(13, 44, 109, 0.3);
}

.chosen-card {
  transform: rotate(5deg);
  box-shadow: 0 8px 24px rgba(13, 44, 109, 0.2);
}

.drag-card {
  transform: rotate(5deg);
  opacity: 0.8;
}

/* Animation for list transitions */
.operation-list-move {
  transition: transform 0.3s ease;
}

.operation-list-enter-active,
.operation-list-leave-active {
  transition: all 0.3s ease;
}

.operation-list-enter,
.operation-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* Status Chips */
.status-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-active {
  background: rgba(34, 197, 94, 0.1);
  color: #16a34a;
}

.status-inactive {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

/* Add Button */
.add-button {
  text-transform: none;
  letter-spacing: 0.5px;
  font-size: 0.9375rem;
  font-weight: 500;
  border-radius: 8px;
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%) !important;
  box-shadow: 0 2px 8px rgba(13, 44, 109, 0.2);
  transition: all 0.3s ease;
}

.add-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(13, 44, 109, 0.3);
}

/* RTL Support */
.v-application {
  direction: rtl;
}

/* Responsive adjustments for drag and drop */
@media (max-width: 960px) {
  .drag-handle {
    top: 4px;
    left: 4px;
  }
}


.horizontal-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* 🟢 זה מה שמאפשר שורות נוספות במקום גלילה */
  padding: 16px;
}


.operation-col {
  min-width: 370px !important;
  /* או כל גודל שמתאים */
  transition: all 0.3s ease;
  margin: 15px;
}
</style>